import Component from '../core/Component'
import PlanFloor from './PlanFloor'
import EventBus from '../core/EventBus'
import { toggleClass } from '../utils/dom'

export const STATES = {
    STATIC: 'is-static',
    ACTIVE: 'is-active'
}

export default class Plan extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            floors: [],
            controls: []
        }

        this.floors = []
        this._static = false
    }

    get static() {
        return this._static
    }

    set static(value) {
        if (value) {
            this.element.classList.add(STATES.STATIC)
        } else {
            this.element.classList.remove(STATES.STATIC)
        }

        this._static = value
    }

    prepare() {
        this.floors = this.ref.floors.map(element => new PlanFloor(element))
        this.floors.forEach(floor => floor.prepare())
        this.ref.controls.forEach(element => element.addEventListener('click', ::this.handleClick))
        EventBus.on('plan:floor:show', this.handlePlanFloorShow)

        if (this.element.dataset.default) {
            this.showFloor(this.element.dataset.default)
        }
    }

    destroy() {
        EventBus.off('plan:floor:show', this.handlePlanFloorShow)
    }

    handlePlanFloorShow = ({ floor }) => {
        this.ref.controls.forEach(element => toggleClass(element, STATES.ACTIVE, `${floor}` === element.dataset.floor))
    }

    handleClick(event) {
        event.preventDefault()
        this.showFloor(event.target.dataset.floor)
    }

    showFloor(floorId, route = null, data = {}) {
        floorId = `${floorId}`

        this.floors.forEach(floor => {
            if (floor.id === floorId) {
                floor.isStatic = this.static
                floor.show(route, data)

            } else {
                floor.hide()
            }
        })
    }

    show(route, data) {
        this.static = !!route
        this.open()
        if (route) {
            let [floor, cell] = route.split('.')
            const floorId = floor.replace('a', '')
            this.showFloor(floorId, route, data)
        } else {
            this.floors.forEach(floor => floor.isStatic = this.static)
            this.showFloor(this.floors[0].id)
        }
    }

    open() {
        const modal = Component.getFromElement('modal-plan')

        if (modal) {
            modal.on('close', this.close)
            modal.open()
        }
    }

    close = () => {
        this.floors.forEach(floor => floor.blur())
        this.showFloor(this.floors[0].id)
    }

}